import { useState } from 'react';

const KEY = 'ysm.banner.v1';

function dismissed(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function CookieBanner() {
  const [hidden, setHidden] = useState(dismissed);
  if (hidden) return null;
  const close = () => {
    try {
      localStorage.setItem(KEY, '1');
    } catch {
      /* private mode: the bar just returns next visit */
    }
    setHidden(true);
  };
  return (
    <aside className="promise-bar" role="region" aria-label="Our data promise">
      <strong>We will NEVER sell your data to advertisers or anyone else.</strong>
      <p>
        Cookies and your browser's storage run the map and remember your search. We also count, in aggregate only, which
        site sent us each visitor.
      </p>
      <div className="row-actions">
        <a href="/privacy">What we collect and why</a>
        <button className="primary" onClick={close}>
          Got it
        </button>
      </div>
    </aside>
  );
}
